import { Cuts } from 'media/constants/constants'

const breakpoints = Object.values(Cuts)

export const getImageWidth = (width: number): number =>
	breakpoints.find((breakpointWidth) => breakpointWidth >= width) ??
	breakpoints[breakpoints.length - 1]
